import swal from "sweetalert";
import AlertIcon from '../assets/icons/alarm.svg'
import MessagesIcon from '../assets/icons/message.svg'
import shareIcon from '../assets/icons/share.svg'
import companyIcon from '../assets/icons/company.svg'
import bookingsIcon from '../assets/icons/email-notification.svg'
import ClockIcon from '../assets/icons/clock.svg'
import CreditCardIcon from '../assets/icons/creditcard.svg'
import AcceptIcon from '../assets/icons/accept.svg'
import InvitationIcon from '../assets/icons/invitation.svg'
import StarIcon from "../assets/icons/star-grey.svg";

const creditActionEnum = [
  {
    label: 'Geef ons feedback',
    value: 'web_feedback',
    credits: 20,
    icon: MessagesIcon,
    text: 'Verdien 20 credits per feedback. Maximaal 40 per dag.',
    onClick: () => {
      swal({
        title: 'Zoek de blauwe feedback buttons',
        text: 'Op deze website vind je meerdere blauwe feedbackknoppen (zoals rechtsboven op deze pagina). Per dag kun je maximaal 40 credits verdienen per feedback. Vind ze allemaal – jouw mening telt!',
        buttons: {
          confirm: {
            text: 'oke',
            value: true,
            visible: true,
            className: 'btn-color-green btn-size-m',
            closeModal: true
          }
        }
      })
    },

    //bar: 2 items per dag = 100%
  },
  {
    label: 'Deel profiel(en) op social media',
    value: 'shared_profile_social_media',
    credits: 200,
    icon: shareIcon,
    text: 'Verdien 200 credits per keer delen. Maximaal 1 keer per maand.',
    onClick: () => {
      swal({
        title: 'Creëer een stand- of locatieprofiel en deel het!',
        text: 'Klik rechtsboven op de "Delen"-knop op je profielpagina. Stuur daarna een bericht naar Standplaats.nl met de link naar je social media waar je het profiel gedeeld hebt, en ontvang 200 credits!',
        buttons: {
          stand: {
            text: 'Stand profielen bekijken',
            value: 'stand',
            visible: true,
            className: 'btn-color-green btn-size-m',
            closeModal: true
          },
          spotGroup: {
            text: 'Locatie profielen bekijken',
            value: 'spotGroup',
            visible: true,
            className: 'btn-color-green btn-size-m',
            closeModal: true
          },
          bericht: {
            text: 'Gedeelt! Link doorgeven',
            value: 'contact',
            visible: true,
            className: 'btn-color-blue btn-size-m',
            closeModal: true
          },
        }
      }).then((result) => {
        if (result === 'stand') {
          window.location.href = '/user/stands'
        }
        if (result === 'spotGroup') {
          window.location.href = '/user/locaties'
        }
        if (result === 'contact') {
          window.location.href = '/user/berichten/1'
        }
      })

    },

    //bar: unlimited:
  },
  {
    label: 'Stuur uitnodigingen',
    value: 'referenced_user',
    credits: 200,
    text: 'Verdien 200 credits per uitnodiging, nadat de gebruiker een account heeft aangemaakt. Je kan zoveel uitnodigingen sturen als je wil.',
    icon: InvitationIcon,
    onClick: '/user/invite',

    //bar: unlimited
  },
  {
    label: 'Stuur 5 boekingsverzoeken in 1 week',
    value: 'sent_5_booking_requests',
    credits: 100,
    text: 'Verdien 100 credits voor elke week waarin je meer dan boekingsverzoeken verstuurd.',
    icon: bookingsIcon,
    onClick: null,

    //bar: 5 items per week = 100%
  },
  {
    label: 'Accepteer een boeking binnen 24 uur',
    value: 'accepted_booking_within_24_hours',
    text: 'Verdien 20 credits per boeking die je binnen 24 uur accepteert.',
    credits: 20,
    icon: ClockIcon,
    onClick: null,

    //bar: unlimited
  },
  {
    label: 'Betaal een boeking binnen 24 uur',
    value: 'payed_booking_within_24_hours',
    credits: 20,
    text: 'Verdien 20 credits per boeking die je binnen 24 uur betaalt. Dit geldt alleen voor boekingen die vooraf betaalt moeten worden, en het bedrag hoger is dan 5,- euro.',
    icon: CreditCardIcon,
    onClick: null,

    //bar: unlimited
  },
  {
    label: 'Verifieer jouw account',
    value: 'verified_company',
    credits: 100,
    text: 'Verdien eenmalig 100 credits als je jouw account verifieert.',
    icon: companyIcon,
    onClick: '/user/organisaties',

    //bar: 1 item = 100%
  },
  {
    label: 'Activeer Automatische Incasso & achteraf betalen',
    value: 'activated_pay_after_and_direct_debit',
    text: 'Verdien eenmalig 100 credits als je automatische incasso (DirectDebit) activeert en instelt als standaard betaalmethode, en achteraf betalen instelt als standaard.',
    credits: 100,
    icon: AcceptIcon,
    onClick: '/user/organisaties',

    //bar: 1 item = 100%
  },
  {
    label: 'Zoek alert instellen',
    value: 'added_alert',
    credits: 10,
    text: 'Verdien 10 credits per alert die je instelt. Verdien maximaal 10 credits per dag.',
    icon: AlertIcon,
    onClick: '/user/zoek-alerts',

    //bar: 1 item per dag = 100%
  },


  {
    label: '',
    value: 'spent_on_booking_fee',
    credits: -250,
    text: '',
    icon: StarIcon,
  },

  {
    label: '',
    value: 'spent_on_profile_boost',
    credits: -1000,
    text: '',
    icon: StarIcon,
  },
]

export default creditActionEnum;